// removed by extract-text-webpack-plugin
module.exports = {"error":"error___33TYy"};


//////////////////
// WEBPACK FOOTER
// ./src/routes/error/index.less
// module id = 744
// module chunks = 3